import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

interface CSVData {
  [key: string]: string;
}

interface UseCSVResult {
  csvData: CSVData;
  error: Error | null;
}

const useCountryCode = (path: string): UseCSVResult => {
  // const [csvData, setCsvData] = useState<CSVData[]>([]);
  const [csvData, setCsvData] = useState<{ [key: string]: string }>({});
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchCSV = async () => {
      try {
        const response = await fetch(path);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const reader = response.body?.getReader();
        if (!reader) {
          throw new Error('Reader not available');
        }
        const result = await reader.read();
        const decoder = new TextDecoder('utf-8');
        const csv = decoder.decode(result.value);
        Papa.parse<{ country: string; region: string }>(csv, {
          complete: (result) => {
            const data: CSVData = result.data.reduce((acc, item) => {
              acc[item.country] = item.region;
              return acc;
            }, {} as CSVData);
            setCsvData(data);
          },
          header: true,
        });
      } catch (err) {
        setError(err as Error);
      }
    };

    fetchCSV();
  }, [path]);

  return { csvData, error };
};

export default useCountryCode;
